module.exports = __webpack_public_path__ + "ef0386caf4a76ebff26e4bdc709c02d2.png";